// extracted by mini-css-extract-plugin
module.exports = {"containedImage":"image_containedImage__kqtpo"};